'use es6';

import Client from 'AdsUI/data/Client';
import calculateTimeRange from 'AdsUI/lib/CalculateTimeRange';
import getAccountIdsByNetwork from 'AdsUI/lib/getAccountIdsByNetwork';
export const fetch = ({
  adAccounts,
  timeRange,
  statuses,
  attributionView
}) => {
  const now = window.performance.now(); // Fetching all campaigns can take a while, especially for portals like 53,
  // so increase timeout to 60s

  return Client.apiRequest('ads/v1/reports/all-campaigns', {
    query: Object.assign({
      status: statuses.toArray()
    }, calculateTimeRange(timeRange), {}, getAccountIdsByNetwork(adAccounts), {
      attributionType: attributionView
    }),
    timeout: 60000
  }).then(results => {
    try {
      window.newrelic.addPageAction('ads-all-campaigns-fetch', {
        'ads-all-campaigns-fetch-duration': window.performance.now() - now,
        'selected-ad-accounts': adAccounts.size
      }); // eslint-disable-next-line
    } catch (e) {}

    return results;
  });
};
export const fetchEarlyRequest = ({
  adAccounts,
  timeRange,
  statuses,
  attributionView
}) => {
  // Fetching all campaigns can take a while, especially for portals like 53,
  // so increase timeout to 60s
  return Client.apiRequest('ads/v1/reports/campaigns-first-page', {
    query: Object.assign({
      status: statuses.toArray()
    }, calculateTimeRange(timeRange), {}, getAccountIdsByNetwork(adAccounts), {
      attributionType: attributionView
    }),
    timeout: 60000
  });
};
export const fetchAllAdSequences = ({
  adAccounts,
  timeRange,
  attributionView
}) => {
  return Client.apiRequest('ads/v1/reports/all-ad-sequences', {
    query: Object.assign({}, calculateTimeRange(timeRange), {}, getAccountIdsByNetwork(adAccounts), {
      attributionType: attributionView
    })
  });
};